import { InjectionToken } from '@angular/core';

/**
 * @deprecated Use the `MuiI18nProvider` instead, as this solution will not react to live changes of the language.
 */
export interface MuiTranslations {
  alert: {
    closeButton: string;
  };
  breadcrumbs: {
    label: string;
  };
  carousel: {
    nextButton: string;
    previousButton: string;
  };
  chip: {
    dismissButton: string;
  };
  modal: {
    basicConfirmButton: string;
    basicDismissButton: string;
    closeButton: string;
  };
  pagination: {
    displayedItemsLabel: (from: number, to: number, total: number) => string;
    nextPageButton: string;
    previousPageButton: string;
    sizeSelectLabel: string;
  },
  password: {
    showPasswordButton: string;
    hidePasswordButton: string;
  };
}

/**
 * This token is used to provide default translations for the MUI components. It can be overridden in the individual apps using
 * external dependencies, e.g. ngx-translate for translated values.
 *
 * The factory here provides default translations in English, but overwriting the defaults with proper translated values should be
 * preferred.
 *
 * @deprecated Use the `MuiI18nProvider` instead, as this solution will not react to live changes of the language.
 */
export const MUI_TRANSLATIONS = new InjectionToken<MuiTranslations>('MUI_TRANSLATIONS', {
  providedIn: 'root',
  factory: (): MuiTranslations => ({
    alert: {
      closeButton: 'Close'
    },
    breadcrumbs: {
      label: 'Breadcrumb'
    },
    carousel: {
      nextButton: 'Next',
      previousButton: 'Previous'
    },
    chip: {
      dismissButton: 'Dismiss'
    },
    modal: {
      basicConfirmButton: 'Confirm',
      basicDismissButton: 'Dismiss',
      closeButton: 'Close'
    },
    pagination: {
      displayedItemsLabel: (from: number, to: number, total: number) => `${from} - ${to} of ${total}`,
      nextPageButton: 'Next items',
      previousPageButton: 'Previous items',
      sizeSelectLabel: 'Items per page',
    },
    password: {
      showPasswordButton: 'Show password',
      hidePasswordButton: 'Hide password'
    }
  })
});
